import { render, staticRenderFns } from "./keyBoard.vue?vue&type=template&id=0cfc7d27&scoped=true&"
import script from "./keyBoard.vue?vue&type=script&lang=js&"
export * from "./keyBoard.vue?vue&type=script&lang=js&"
import style0 from "./keyBoard.vue?vue&type=style&index=0&id=0cfc7d27&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfc7d27",
  null
  
)

export default component.exports